module.exports = __webpack_public_path__ + "img/iwleaveImg.b9ddbcfc.png";